import * as actions from "../actions";
import * as actionsTypes from "../actionTypes";
import {all, fork, put, takeEvery} from "redux-saga/effects";
import ReferenceService from '../../services/referenc.service'

function* getReferencesList(action) {
  try {
    if (action.payload) {
      const page = action.payload?.pageNo;
      const pageSize = action.payload?.pageSize;
      const search = action.payload?.search;
      let params = {page, pageSize, search};
      const response = yield ReferenceService.list(params);
      if (response?.data.statusCode) {
        yield put(actions.getReferencesListSuccess(response?.data?.data));
      } else {
        yield put(actions.getReferencesListFailure("no data"));
      }
    }
  } catch (err) {
    let error = err?.response?.data?.message;
    if (!error) {
      error = err?.response?.message || "network error"
    }
    yield put(actions.getReferencesListFailure(error));
  }
}


function* addNewReferenceStart(action) {
  try {
    const create = action?.payload?.create;
    let id = action?.payload?.id;
    let response = null;
    delete action.payload.create
    delete action?.payload?.id
    if(create)
      response = yield ReferenceService.create(action.payload);
    else 
      response = yield ReferenceService.editReference(id, action.payload);

    // const response = yield ReferenceService.create(action.payload);

    if (response) {
      // HttpService.setToken(response.data.token);
      yield put(actions.addNewReferenceSuccess(response?.data));
    } else {
      yield put(actions.addNewReferenceFailure("Invalid Username/Password"));
    }
  } catch (err) {
    console.log('err?.response?.data?.data?.message ', err?.response?.data?.message)
    let error = err?.response?.data?.message;
    if (!error) {
      error = err?.response?.message || "network error"
    }
    yield put(actions.addNewReferenceFailure(error));
  }
}


function* getReferencesListSaga() {
  yield takeEvery(actionsTypes.GET_REFERENCES_LIST_START, getReferencesList);
}

function* addNewReferencesSaga() {
  yield takeEvery(actionsTypes.ADD_NEW_REFERENCE_START, addNewReferenceStart);
}


export function* referenceSaga() {
  yield all([fork(getReferencesListSaga), fork(addNewReferencesSaga),]);
}
